import BaseModelAPI from '../BaseModelAPI';

export default class IncomingDocumentTypeList extends BaseModelAPI {

	static entity = 'incomingdocumenttypelist'
	static entityName = 'incomingdocumenttype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
